// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.role-timeline-row[data-v-3b562712] {
  display: flex;
  min-height: 35px;
}
.role-timeline-row-name[data-v-3b562712] {
  width: 80px;
  flex: 0 0 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  padding-right: 10px;
  color: #59666e;
  font-size: 15px;
  white-space: nowrap;
  box-sizing: border-box;
  position: sticky;
  left: 0;
  z-index: 1;
  background: #fff;
  overflow: hidden;
}
.role-timeline-row-content[data-v-3b562712] {
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  padding: 0;
  justify-content: space-between;
  gap: 5px;
  height: 100%;
}
.role-timeline-row-track[data-v-3b562712] {
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1440px;
  background: #c4c4c433;
  border-radius: 6px;
  min-height: 35px;
  display: flex;
}
.role-timeline-row-line[data-v-3b562712] {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #dcdfe1;
  pointer-events: none;
}
.role-timeline-row-menu[data-v-3b562712] {
  position: sticky;
  top: 0;
  right: 0;
  width: 35px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #c4c4c433;
  cursor: pointer;
}
.role-timeline-row-menu span[data-v-3b562712] {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #8b8f92;
}
.role-timeline-row-menu[data-v-3b562712]:hover {
  background: #e9e9e9;
}
.role-section-edit-col-overlay[data-v-3b562712] {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff00;
  opacity: 0.1;
  top: 0;
  left: 0;
}
.role-template-table-edit-col[data-v-3b562712] {
  border: 1px solid #fff;
}
.role-template-btn[data-v-3b562712] {
  z-index: 2;
}
.role-template-table-edit-col-wrapper[data-v-3b562712] {
  display: flex;
  position: absolute;
  top: -10px;
  right: 20px;
  background: #fff;
  width: fit-content;
  height: 45px;
  border-radius: 5px;
  box-shadow: 0px 0px 7px 0px #747474;
}
.role-template-table-edit-col-wrapper .oplus-icon[data-v-3b562712] {
  padding: 0 5px;
}
`, "",{"version":3,"sources":["webpack://./src/role/components/RoleTimeRow.vue"],"names":[],"mappings":";AAoCA;EACE,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,MAAM;EACN,OAAO;AACT;AACA;EACE,sBAAsB;AACxB;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB","sourcesContent":["<script setup lang=\"ts\">\nimport { RoleView } from \"../../viewModel/role\";\nimport RoleTimeBlock from \"./RoleTimeBlock.vue\";\nimport { getRolePosition } from \"../roleTimeLayout\";\n\nconst props = defineProps<{\n  role: RoleView;\n  timeRange: {\n    start: number;\n    end: number;\n  };\n}>();\n</script>\n\n<template>\n  <div class=\"role-timeline-row\">\n    <!-- role-Timeline -->\n    <div class=\"role-timeline-row-content\">\n      <div class=\"role-timeline-row-track\">\n        <!-- Role Block -->\n        <RoleTimeBlock :role=\"role\" :time-range=\"timeRange\" />\n        <!-- Hour grid -->\n        <div\n          v-for=\"hour in timeRange.end - timeRange.start + 1\"\n          :key=\"hour\"\n          class=\"role-timeline-row-line\"\n          :style=\"{\n            left: `${getRolePosition(hour - 1 + props.timeRange.start, props.timeRange.start, props.timeRange.end)}%`,\n          }\"\n        ></div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.role-timeline-row {\n  display: flex;\n  min-height: 35px;\n}\n\n.role-timeline-row-name {\n  width: 80px;\n  flex: 0 0 80px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  text-align: right;\n  padding-right: 10px;\n  color: #59666e;\n  font-size: 15px;\n  white-space: nowrap;\n  box-sizing: border-box;\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  background: #fff;\n  overflow: hidden;\n}\n\n.role-timeline-row-content {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  padding: 0;\n  justify-content: space-between;\n  gap: 5px;\n  height: 100%;\n}\n\n.role-timeline-row-track {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  min-width: 1440px;\n  background: #c4c4c433;\n  border-radius: 6px;\n  min-height: 35px;\n  display: flex;\n}\n\n.role-timeline-row-line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: #dcdfe1;\n  pointer-events: none;\n}\n.role-timeline-row-menu {\n  position: sticky;\n  top: 0;\n  right: 0;\n  width: 35px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: #c4c4c433;\n  cursor: pointer;\n}\n\n.role-timeline-row-menu span {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: #8b8f92;\n}\n\n.role-timeline-row-menu:hover {\n  background: #e9e9e9;\n}\n\n.role-section-edit-col-overlay {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: #ffffff00;\n  opacity: 0.1;\n  top: 0;\n  left: 0;\n}\n.role-template-table-edit-col {\n  border: 1px solid #fff;\n}\n\n.role-template-btn {\n  z-index: 2;\n}\n.role-template-table-edit-col-wrapper {\n  display: flex;\n  position: absolute;\n  top: -10px;\n  right: 20px;\n  background: #fff;\n  width: fit-content;\n  height: 45px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 7px 0px #747474;\n}\n.role-template-table-edit-col-wrapper .oplus-icon {\n  padding: 0 5px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
